<template>
  <div>
    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      @add="onAdd"
      @edit="onEdit"
      class="container"
      :switchable="isSelecting"
      default-tag-text="默认"
    >
      <div slot="top">
        <van-cell
          :title="defaultAddress.isDefault ? ''+defaultAddress.name+' '+defaultAddress.tel : isDefaultAddress"
          :label="defaultAddress.address"
          border
          center
          clickable
          style="margin-bottom: 2px;
    border-bottom: 1px solid #f4f4f4;"
        >
          <template slot="default">
            <van-tag type="danger">默认地址</van-tag>
          </template>
        </van-cell>
      </div>
    </van-address-list>
  </div>
</template>
<script>
import { AddressList, Toast, Cell, Panel, Icon, Tag } from "vant";
import service from "../../../api/user/address";
export default {
  components: {
    [AddressList.name]: AddressList,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [Panel.name]: Panel,
    [Icon.name]: Icon,
    [Tag.name]: Tag
  },
  data() {
    return {
      chosenAddressId: "1",
      list: [],
      disabledlist: [],
      defaultAddress: {},
      isSelecting: false,
      isDefaultAddress: "请设置默认地址"
    };
  },

  methods: {
    onAdd() {
      this.$router.push({
        name: "addressedit",
        query: { id: 0, type: "add" }
      });
    },
    onEdit(item) {
      this.$router.push({
        name: "addressedit",
        query: { id: item.id, type: "update" }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    service
      .getAddress()
      .then(response => {
        let tData = [];
        let defaultData = [];
        response.data.map(v => {
          tData.push({
            id: v.id,
            tel: v.cellPhone,
            name: v.name,
            address: v.province + v.city + v.country + v.detailAddress,
            isDefault: v.isDefault
          });
          if (v.isDefault) {
            defaultData = {
              id: v.id,
              tel: v.cellPhone,
              name: v.name,
              address: v.province + v.city + v.country + v.detailAddress,
              isDefault: v.isDefault
            };
          }
        });
        next(vm => {
          vm.list = tData;
          vm.defaultAddress = defaultData;
        });
      })
      .catch(error => {
        if (error.status == 404) {
          next(vm => {
            vm.showEmpty = true;
          });
        }
      });
  },
  created() {}
};
</script>
<style lang="less" scoped>
.container {
  // position: fixed;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  // background: #f4f4f4;
  .van-address-item__address {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80vw;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size:  12px;
    color: #a8a8a8;
  }
  .van-cell {
    font-size: 4.3vw;
  }
  .van-address-item__name {
    font-size: 14px;
  }
  .van-cell__value {
    flex: none;
  }
}
</style>